import { render } from "./NavigationTabContainer.vue?vue&type=template&id=6dd6182f"
import script from "./NavigationTabContainer.vue?vue&type=script&lang=ts"
export * from "./NavigationTabContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script